import React from 'react';
import PropTypes from 'prop-types';
import {
  CAC_CREATE_NEW_PROJECT,
  CAC_DUPLICATE_PROJECT,
  CAC_EDIT_PROJECT_NAME,
  CAC_CLUSTER_SEGMENT_INDEX,
  CAC_CLUSTER_SEGMENT_MEAN,
  CAC_CLUSTER_SEGMENT_STANDARD_DEVIATION,
  CAC_CLUSTER_SEGMENT_ABSOLUTE_DEVIATION,
} from '../CacConstants';
import { useProjectContext } from "../context/ProjectContext";

const CacDropButtons = props => {
  const { label, infoBoxRef, inputElement, setCompareValue, hoverValue } = props;

  const { addNewProject, duplicateActiveProject } = useProjectContext();

  const handleDropdownClick = label => {
    
    switch (label) {
      case CAC_CREATE_NEW_PROJECT: {
        addNewProject();
        break;
      }
      case CAC_DUPLICATE_PROJECT: {
        duplicateActiveProject();
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case CAC_EDIT_PROJECT_NAME: {
        inputElement.current.startEditing();
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case CAC_CLUSTER_SEGMENT_INDEX.label: {
        setCompareValue(CAC_CLUSTER_SEGMENT_INDEX)
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case CAC_CLUSTER_SEGMENT_MEAN.label: {
        setCompareValue(CAC_CLUSTER_SEGMENT_MEAN)
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      case CAC_CLUSTER_SEGMENT_STANDARD_DEVIATION.label: {
        setCompareValue(CAC_CLUSTER_SEGMENT_STANDARD_DEVIATION);  
        infoBoxRef.current.targetRef.current.click();      
        break;
      }
      case CAC_CLUSTER_SEGMENT_ABSOLUTE_DEVIATION.label: {
        setCompareValue(CAC_CLUSTER_SEGMENT_ABSOLUTE_DEVIATION);
        infoBoxRef.current.targetRef.current.click();
        break;
      }
      default: break;
    }
  };

  const getLabelForDropDownButton = (label, hoverValue) => {
    if (hoverValue) {
      return <span title={hoverValue}>{label}</span>
    } 
    return label;
  };

  return (
    <div className="toggleLabel" data-test="dropButtonComponent">
      <button
        type="button"
        className="toggleHeading"
        onClick={() => handleDropdownClick(label)}
      >
        { getLabelForDropDownButton(label, hoverValue) }
      </button>
    </div>
  );
};

CacDropButtons.propTypes = {
  setCompareValue: PropTypes.func,
  label: PropTypes.string,
  infoBoxRef: PropTypes.shape({
    current: PropTypes.shape({
      targetRef: PropTypes.shape({
        current: PropTypes.shape({
          click: PropTypes.func,
        })
      }),
    }),
  }),
  inputElement: PropTypes.shape({
    current: PropTypes.shape({
      startEditing: PropTypes.func,
    }),
  }),
};

export default CacDropButtons;
